import { twMerge } from "tailwind-merge";
import DropdownPanel, { DropdownPanelProps } from "./dropdownPanel";

export interface DropdownMenuProps extends DropdownPanelProps {}

const DropdownMenu = (props: Readonly<DropdownMenuProps>) => {
  const { className, ...rest } = props;
  return (
    <DropdownPanel
      {...rest}
      className={twMerge("max-h-80 w-[350px]", className)}
    />
  );
};

export default DropdownMenu;
